import React from 'react';
import {Button, Modal, SpaceBetween} from '@amzn/awsui-components-react-v3';

const HEADING = 'Download Data';
const CONTENT_HEADING = 'DOWNLOAD REPORT AS';
const LABELS = Object.freeze({
  CANCEL: 'Cancel',
  ROW_WISE_COMPARISON: 'Row-wise Comparison',
  SIDE_BY_SIDE_COMPARISON: 'Side by side Comparison',
});

export class DownloadReportDataWindow extends React.Component {
  constructor(props) {
    super(props);
  }

  onCancel = () => {
    this.props.onCancel();
  };

  onRowWiseComparisonDownload = () => {
    this.props.onSubmit('rows');
  };

  onSideBySideComparisonDownload = () => {
    this.props.onSubmit('columns');
  };

  render() {
    return (
      <Modal
        visible={true}
        size="medium"
        header={HEADING}
        expandToFit={true}
        onDismiss={this.onCancel}
        footer={
          <span className="awsui-util-f-r">
            <SpaceBetween direction="horizontal" size="xs">
              <Button onClick={this.onCancel} > {LABELS.CANCEL} </Button>
              <Button variant="primary" onClick={this.onRowWiseComparisonDownload} >
                {LABELS.ROW_WISE_COMPARISON}
              </Button>
              <Button
                variant="primary"
                onClick={this.onSideBySideComparisonDownload}
              >
                  {LABELS.SIDE_BY_SIDE_COMPARISON}
              </Button>
            </SpaceBetween>
          </span>
        }
      >
        <div>
          <h4 className="awsui-util-t-c">
            {CONTENT_HEADING}
            <br />
            <br />
          </h4>
        </div>
      </Modal>
    );
  }
}

export default DownloadReportDataWindow;



// WEBPACK FOOTER //
// ./src/components/reports/components/download_report_data_window.js